import React from 'react'
import styled from '@emotion/styled'

const Container = styled.div`
	padding: 3rem 0 0 0;
	overflow: visible;
`

const Wrapper = styled.div`
	margin: 0 auto;
	text-align: center;
	padding-bottom: 3rem;
	position: relative;
`

const Background = styled.div`
	position: absolute;
	top: 150px;
	right: 0;
	z-index: -1;
	width: 100%;
	height: 100%;
`

const Header = styled.div`
	display: flex;
    flex-direction: column;
	h1 {
		max-width: 40rem;
		margin:0 auto;
		margin-bottom: 20px;
		font-size: 2.3rem;
		font-family: 'Avenir Next'
	}
	a {
		margin: auto;
	}
	p {
		font-family: 'Avenir Next'
	}
`

export default () => (
	<Container>
		<Wrapper>
			<Header>
				<h1>Keep track of the companies tracking you.</h1>
				<p>Download, redact, and control the information companies collect on you.</p>
			</Header>
		</Wrapper>
	</Container>
)